var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#53ADF8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.1,18C1,22.2,1,29.1,5.1,33.4l24.5,25.4l1.6,1.7l0,0c2,2.1,4.7,3.2,7.4,3.2s5.4-1.1,7.4-3.2l6.2-6.4 c1.4-1.4,1.4-3.7,0-5.1c-1.4-1.4-3.6-1.4-4.9,0l-6.2,6.4c-1.4,1.4-3.6,1.4-5,0l0,0L10,28.4c-1.4-1.4-1.4-3.7,0-5.1l12.4-12.8 c1.4-1.4,3.6-1.4,5,0L38.7,22c1.4,1.4,3.6,1.4,4.9,0c1.4-1.4,1.4-3.7,0-5.1L32.3,5.2C28.2,1,21.5,1,17.5,5.2L5.1,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.4,69c-1.4,1.4-1.4,3.7,0,5.1l11.3,11.7c2,2.1,4.7,3.2,7.4,3.2s5.4-1.1,7.4-3.2L82.9,73 c4.1-4.2,4.1-11.1,0-15.4l-26.1-27c-4.1-4.2-10.8-4.2-14.8,0L35.8,37c-1.4,1.4-1.4,3.7,0,5.1c1.4,1.4,3.6,1.4,4.9,0l6.2-6.4 c1.4-1.4,3.6-1.4,5,0l26.1,27c1.4,1.4,1.4,3.7,0,5.1L65.6,80.7c-1.4,1.4-3.6,1.4-5,0L49.3,68.9C48,67.5,45.8,67.5,44.4,69z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.480c09b7e82e03fe764646a92f09244d.svg";
export { ForwardRef as ReactComponent };